<ion-app>
  <app-sidemenu></app-sidemenu>
  <ion-router-outlet id="content1"></ion-router-outlet>
</ion-app>
